import React from 'react';
import Style from './Portfolio.module.scss';
import { Reveal } from '../ui/Reveal';
import { ArrowUpRight, GitHubIcon } from '../ui/Icons';

export default function PortfolioBlock({ project, delay = 0 }) {
    const { slug, title, source, live, ms, description, tech, badge } = project;

    return (
        <Reveal delay={delay}>
            <a href={source} target="_blank" rel="noopener noreferrer" className={Style.card}>
                <p className={Style.requestLine}>
                    <span className={Style.method}>GET</span> /projects/{slug}
                    <span className={Style.status}>200 · {ms}</span>
                </p>
                <div className={Style.cardHead}>
                    <h3 className={Style.cardTitle}>{title}</h3>
                    <span className={Style.badge}>{badge}</span>
                </div>
                <p className={Style.cardDesc}>{description}</p>
                <div className={Style.cardFoot}>
                    <div className={Style.tech}>
                        {tech.map((t) => <span key={t}>{t}</span>)}
                    </div>
                    <span className={Style.cardLink}>
                        {live ? <ArrowUpRight size={15} /> : <GitHubIcon size={15} />}
                    </span>
                </div>
            </a>
        </Reveal>
    );
}
